import { ClockifyTimeEntryTimeAlertState } from "./ClockifyTimeEntryTimeAlertState";
import { PercentageCompleteChangedAlertState } from "./percentageCompleteChangedAlert/PercentageCompleteChangedAlertState";
import { MilestoneTaskEstimateAlertState } from './MilestoneTaskEstimateAlertState';

export interface AlertsState {
  milestoneTaskEstimateAlertState: MilestoneTaskEstimateAlertState;
  clockifyTimeEntryTimeAlertState: ClockifyTimeEntryTimeAlertState;
  percentageCompleteChangedAlertState: PercentageCompleteChangedAlertState;
  clockifyTimeEntryTimeChangedReadAlerts: { id: number }[];
  milestoneTaskEstimateProcessedAlertIds: number[];
  percentageCompleteProcessedAlertIds: number[];
}

export const initialAlertsState: AlertsState = {
  milestoneTaskEstimateAlertState: {
    milestoneTaskEstimateChangedAlerts: [],
    milestoneTaskEstimateReadAlerts: [],
    processedAlertIds: [],
    initializationStatus: "not-initialized",
    alertReadEventInitializationStatus: "not-initialized"
  },
  clockifyTimeEntryTimeAlertState: {
    clockifyTimeChangedAlerts: [],
    clockifyTimeChangedReadAlerts: [],
    processedAlertIds: [],
    initializationStatus: "not-initialized",
    alertReadEventInitializationStatus: "not-initialized"
  },
  percentageCompleteChangedAlertState: {
    percentageCompleteChangedAlerts: [],
    percentageCompleteChangedReadAlerts: [],
    processedAlertIds: [],
    initializationStatus: "not-initialized",
    alertReadEventInitializationStatus: "not-initialized"
  },
  clockifyTimeEntryTimeChangedReadAlerts: [],
  milestoneTaskEstimateProcessedAlertIds: [],
  percentageCompleteProcessedAlertIds: [],
};
